import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, EmptyState } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { TemplateDrawerContent } from 'app/domains/esigning/components/TemplateDrawer';
import { DefaultRecipientModal } from '../DefaultRecipientModal';
export function NoRecipientsState(props) {
    const { onAddRecipient } = props;
    const [renderDialog, setRenderDialog] = useState(false);
    const showDialog = () => setRenderDialog(true);
    const hideDialog = () => setRenderDialog(false);
    const handleSubmit = (recipient) => {
        onAddRecipient(recipient);
        hideDialog();
    };
    return (<Fragment>
      {renderDialog && <DefaultRecipientModal allRecipients={[]} onClose={hideDialog} onSubmit={handleSubmit}/>}
      <TemplateDrawerContent>
        <EmptyState withAvatar icon={<Falcon icon="pen-swirl"/>} title={t({
            comment: 'Manage template esigning parties - empty state - title',
            message: 'No parties added',
        })} description={t({
            comment: 'Manage template esigning parties - empty state - description',
            message: 'All your default signing parties will be listed here',
        })} actions={<Button size="small" appearance="primary" onClick={showDialog}>
              <Trans comment="Manage template esigning parties - empty state - add default signing party call to action label">
                Add party
              </Trans>
            </Button>}/>
      </TemplateDrawerContent>
    </Fragment>);
}
